import React from "react";
import i18n from "../../i18n";
import { Select } from "antd";


const LanguageSwitcher = () => {
  const currentLang =
    i18n.language || localStorage.getItem("i18nextLng") || "en";

  const changeLanguage = (lang) => {
    localStorage.setItem("lang", lang);
    i18n.changeLanguage(lang);
  };

  return (
    <div className={`relative `}>
      <select
        className="text-black bg-white  p-2 pe-3 rounded cursor-pointer"
        onChange={(e) => changeLanguage(e.target.value)}
        value={currentLang}
      >
        <option value="en">English</option>
        <option value="th">Thai</option>
        <option value="vi">Vietnamese</option>
      </select>
    </div>
  );
};

export default LanguageSwitcher;
